import { useEffect, useRef } from 'react';

const SITE_KEY = process.env.REACT_APP_TURNSTILE_SITE_KEY;

// Captcha Cloudflare Turnstile (render explícito)
export const TurnstileWidget = ({ onToken }) => {
  const box = useRef(null);
  const widget = useRef(null);
  useEffect(() => {
    let timer;
    const render = () => {
      if (!box.current || !window.turnstile || widget.current !== null) return;
      widget.current = window.turnstile.render(box.current, {
        sitekey: SITE_KEY, action: 'register',
        callback: onToken, 'error-callback': () => onToken(''), 'expired-callback': () => onToken(''), 'timeout-callback': () => onToken(''),
      });
    };
    if (window.turnstile) render();
    else timer = setInterval(() => { if (window.turnstile) { clearInterval(timer); render(); } }, 150);
    return () => {
      clearInterval(timer);
      if (widget.current !== null && window.turnstile) window.turnstile.remove(widget.current);
      widget.current = null;
    };
  }, [onToken]);
  return <div ref={box} data-testid="turnstile-widget" aria-label="Verificación anti-robots" />;
};
